import React, { useEffect, useRef, useState } from "react";
import Attachments from "../../../components/Attachments/Attachments";
import Notifications from "../../../components/Notifications/Notifications";
import { IoMdNotificationsOutline } from "react-icons/io";
import { useStateValue } from "../../../StateProvider";
import { useForm } from "react-hook-form";
import {
  addTaskTemp,
  editeTaskTemplate,
  editeUser,
  getSignupReDetail,
  getTaskTempOrderNo,
  getTaskTemplateDetail,
  signup,
} from "../../../apiCall";
import toast from "react-hot-toast";
// import { DateToYYYYMMDD } from "../../../../utils/FormateDate";
import AddSubTask from "../component/AddUpdateSubTask/AddUpdateSubTask";
import SubTaskList from "./Components/SubTaskList";
import { ExtractDays } from "../../../utils/ExtractDays";
// import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { useNavigate, useParams } from "react-router-dom";
import EncodeAprxDuration from "../../../utils/EncodeAprxDuration";
import DecodeAprxDuration from "../../../utils/DecodeAprxDuration";
import Attachment from "../../Attachment/Attachment";
import { validateNoBlankSpaces } from "../../../utils/formValidation";

const AddUpdateTaskTemp = () => {
  const [tab, setTab] = useState("information");
  const [, dispatch] = useStateValue();
  const navigate = useNavigate();
  const [isSaveAndAddSubTask, setIsSaveAndAddSubTask] = useState(false);
  const [isSaveAndEditSubTask, setIsSaveAndEditSubTask] = useState(false);
  const [editSubTaskId, setEditSubTaskId] = useState();
  const { temId } = useParams();
  const { projectId, projectName } = useParams();
  const [tName, setTName] = useState("");
  const [pName, setPName] = useState("");
  const [pId, setPID] = useState("");
  const [taskData, setTaskData] = useState({});

  //******************************************attachment start **************************************************
  const [attachmentCount, setAttachmentCount] = useState(0);
  const [isAddAttachments, setIsAddAttachments] = useState(false);
  const [title, setTitle] = useState("Add Sub-Task");
  const formRef = useRef(null);
  const updateUrl = (newPath) => {
    const currentUrl = new URL(window.location.href);
    const searchParams = new URLSearchParams(currentUrl.search);

    // Construct new URL
    // const newPath = '/update/task/31';
    const newUrl = `${newPath}?${searchParams.toString()}`;

    // Navigate to the new URL
    navigate(newUrl);
  };

  const handleExternalSubmit = () => {
    if (tab === "information") {
      setIsAddAttachments(true);
      if (formRef.current) {
        setTimeout(() => {
          formRef.current.dispatchEvent(
            new Event("submit", { cancelable: true, bubbles: true })
          );
        }, 100);
      }
    } else {
      setTab("attachments");
      setTitle(
        projectId ? "Update Task Template Form" : "Add Task Template Form"
      );
    }
  };
  useEffect(() => {
    if (temId && tab === "information") {
      setTitle("Update Task Template Form");
    }
    if (!temId && tab === "information") {
      setTitle("Add Task Template Form");
    }
  }, [temId]);
  //******************************************attachment end **************************************************
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      AprxDays: 0,
      AprxHours: 0,
      AprxMinutes: 0,
    },
  });
  const onSubmit = async (data) => {

    if (
      (parseInt(data?.AprxDays) === 0 || data?.AprxDays === "") &&
      (parseInt(data?.AprxMinutes) === 0 || data?.AprxMinutes === "") &&
      (parseInt(data?.AprxHours) === 0 || data?.AprxHours === "")
    ) {
      toast.error("Days, hours and minutes cannot be 0.");
    } else {
      dispatch({ type: "SET_LOADING", status: true });
      const totalDays = EncodeAprxDuration(
        data?.AprxDays === "" ? 0 : data?.AprxDays,
        data?.AprxHours === "" ? 0 : data?.AprxHours,
        data?.AprxMinutes === "" ? 0 : data?.AprxMinutes
      );
      if (data.OrdNo === "") {
        delete data.OrdNo;
      }
      data.AprxDuration = totalDays;
      delete data.AprxDays;
      delete data.AprxHours;
      delete data.AprxMinutes;
      if (temId) {
        if (
          taskData?.ID === data?.ID &&
          taskData?.OrdNo === data?.OrdNo &&
          taskData?.Name === data?.Name &&
          taskData?.Dscr === data?.Dscr &&
          taskData?.AprxDuration === data?.AprxDuration
        ) {
          if (isSaveAndEditSubTask) {
            setIsSaveAndEditSubTask(false);
            navigate(`/update/subtask/${editSubTaskId}`);
          }
          else if (isAddAttachments) {
            setTab("attachments");
            setTitle(
              projectId ? "Update Task Template Form" : "Add Task Template Form"
            );
            setIsAddAttachments(false);
          }
          else {
            if (isSaveAndAddSubTask) {
              setIsSaveAndAddSubTask(false);

              if (pId) {
                navigate(
                  `/project/${pId}/${pName}/add/subtask/${data.ID}/${data?.Name}`
                );
              } else {
                navigate(`/add/subtask/${data.ID}/${data?.Name}`);
              }
            } else {
              if (taskTempDetail?.data?.ProjTmplID) {
                navigate(
                  `/update/project-template/${taskTempDetail?.data?.ProjTmplID}?taskId=${temId}`
                );
              } else {
                navigate(`/task-template?taskId=${temId}`);
              }
            }
          }
        } else {
          const re = await editeTaskTemplate(temId, data);
          if (re?.status === 200) {
            console.log(re);
            toast.success(re?.data?.status);
            if (isSaveAndEditSubTask) {
              reset();
              setIsSaveAndEditSubTask(false);
              navigate(`/update/subtask/${editSubTaskId}`);
            } else if (isAddAttachments) {
              setTab("attachments");
              setTitle(
                temId ? "Update Task Template Form" : "Add Task Template Form"
              );
              setIsAddAttachments(false);
            } else {
              reset();

              if (isSaveAndAddSubTask) {
                setIsSaveAndAddSubTask(false);

                if (pId) {
                  navigate(
                    `/project/${pId}/${pName}/add/subtask/${data.ID}/${data?.Name}`
                  );
                } else {
                  navigate(`/add/subtask/${data.ID}/${data?.Name}`);
                }
              } else {
                if (taskTempDetail?.data?.ProjTmplID) {
                  navigate(
                    `/update/project-template/${taskTempDetail?.data?.ProjTmplID}?taskId=${temId}`
                  );
                } else {
                  navigate(`/task-template?taskId=${temId}`);
                }
              }
            }
          } else if(re?.response) {
            toast.error(re?.response?.data?.message);
          }
        }
      } else {
        data.ProjTmplID = projectId;
        const re = await addTaskTemp(data);
        if (re?.status === 201) {
          console.log(re);
          // setActiveTab("taskTempList");
          reset();
          if (isSaveAndAddSubTask) {
            setIsSaveAndAddSubTask(false);
            if (pId) {
              navigate(
                `/project/${pId}/${pName}/add/subtask/${re.data.data.ID}/${data?.Name}`
              );
            } else {
              navigate(`/add/subtask/${re.data.data.ID}/${data?.Name}`);
            }
          }
          else if (isAddAttachments) {
            setTab("attachments");
            updateUrl(`/update/task-template/${re?.data?.data?.ID}`);
            setTitle(
              temId ? "Update Task Template Form" : "Add Task Template Form"
            );

            setIsAddAttachments(false);
          }
          else {
            if (pId) {
              navigate(
                `/update/project-template/${pId}?taskId=${re.data.data.ID}`
              );
            } else {
              navigate(`/task-template?taskId=${re.data.data.ID}`);
            }
          }

          toast.success(re?.data?.status);
        } else if(re?.response) {
          toast.error(re?.response?.data?.message);
        }
      }
      dispatch({ type: "SET_LOADING", status: false });
    }
  };

  // ************** get task template data start **************************
  const fetchTask = async () => {
    // Perform the API call to fetch company info
    try {
      dispatch({ type: "SET_LOADING", status: true });

      const response = await getTaskTemplateDetail(temId);
      if (response?.status === 200) {
        // setTaskTempList(response.data.data);
        if (response.data?.ProjTmplID) {
          setPName(response.data?.parent_project_template_name);
          setPID(response.data?.ProjTmplID);
          // setValue("ProjTmplID", response.data?.ProjTmplID);
        }
        setTaskData({
          ID: response.data?.ID,
          OrdNo: response.data?.OrdNo,
          Name: response.data?.Name,
          Dscr: response.data?.Dscr,
          AprxDuration: response.data?.AprxDuration,
        });
        setAttachmentCount(response.data?.attachments_no);

        setValue("ID", response.data?.ID);
        setValue("OrdNo", response.data?.OrdNo);
        setValue("Name", response.data?.Name);
        setTName(response.data?.Name);
        setValue("Dscr", response.data?.Dscr);
        const [days, hours, minutes] = DecodeAprxDuration(
          response?.data?.AprxDuration
        );
        setValue("AprxDays", days);
        setValue("AprxHours", hours);
        setValue("AprxMinutes", minutes);
      } else if(response?.response) {
        toast.error(response.response.data.message);
      }
      dispatch({ type: "SET_LOADING", status: false });

      return response;
    } catch (error) {
      console.error("Error fetching data:", error); // Log any errors that occur
      throw error;
      return error;
    }
  };
  const { data: taskTempDetail, refetch } = useQuery({
    queryKey: ["task-temp-detail"],
    queryFn: fetchTask,
    enabled: temId ? true : false,
    // staleTime: Infinity,
    onSuccess: (Re) => {
      console.log(Re);
    },
    onError: (e) => {
      console.log(e);
    },
  });
  useEffect(() => {
    setPName("");
    console.log();
  }, []);

  useEffect(() => {
    console.log(projectId, temId, pName);
    if (projectId) {
      setValue("ProjTmplID", projectId);
      setPID(projectId);
    }
    if (projectName) {
      setPName(projectName);
    } else {
      setPName("");
    }
  }, [projectId, projectName]);

  useEffect(() => {
    const fetchData = async () => {
      dispatch({ type: "SET_LOADING", status: true });

      try {
        if (projectId) {
          const re = await getTaskTempOrderNo(projectId);
          if (re?.status === 200) {
            setValue("OrdNo", parseInt(re?.data?.data));
          } else if(re?.response) {
            toast.error(re?.response?.data?.message);
          }
        }
      } catch { }
      dispatch({ type: "SET_LOADING", status: false });
    };
    fetchData();
  }, [projectId]);

  return (
    <div id="app-content">
      {/* Container fluid */}
      <div className="app-content-area mb-10">
        <div className="container-fluid ">
          <div className="mx-n6 mt-n6 pt-6 mb-6 header">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-12">
                {/* Page header */}
                <div
                  className="d-lg-flex
          align-items-center justify-content-between  px-6"
                >
                  <div className="mb-lg-0">
                    <div className="d-flex align-items-center">
                      <div className="">
                        <h1 className="mb-0 h3 ">
                          {title}
                          {/* {temId ? "Update" : "Add"} Task Template Form */}
                        </h1>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  {/* nav  */}
                  <ul className="nav nav-lb-tab px-6">
                    <li className="nav-item ms-0 me-3">
                      <div
                        role="button"
                        // className="nav-link active "
                        className={`${tab === "information"
                            ? "nav-link active "
                            : "nav-link"
                          }`}
                        onClick={() => {
                          setTab("information");
                          setTitle(
                            projectId
                              ? "Update Task Template Form"
                              : "Add Task Template Form"
                          );
                        }}
                      >
                        Information
                      </div>
                    </li>
                    <li className="rounded-circl notification-count nav-item mx-3">
                      <div
                        role="button"
                        className={`${tab === "attachments"
                            ? "nav-link active "
                            : "nav-link"
                          }`}
                        onClick={() => {
                          handleExternalSubmit();
                        }}
                      >
                        Attachments
                      </div>
                      <div
                        className="notification-count d-flex justify-content-center"
                        style={{ top: "3px", right: "-14px" }}
                      >
                        {attachmentCount}
                      </div>
                    </li>
                    {/* <li className="nav-item mx-3">
                      <div
                        role="button"
                        className={`${
                          tab === "notifications"
                            ? "nav-link active "
                            : "nav-link"
                        }`}
                        onClick={() => setTab("notifications")}
                      >
                        Notifications
                      </div>
                    </li> */}
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 col-md-12 col-12">
              {/* Page header */}
              {/* <div className="mb-5">
                <h3 className="mb-0 ">Add Staff</h3>
              </div> */}
            </div>
          </div>
          <div>
            {/* row */}
            <div className="row">
              <div className="col-xl-12 col-md-12 col-12">
                {/* card */}
                {(() => {
                  switch (tab) {
                    case "information":
                      return (
                        <form onSubmit={handleSubmit(onSubmit)} ref={formRef}>
                          <div className="card ">
                            {/* card body */}
                            <div className="card-body" style={{ padding: "10px" }}>
                              {/* form */}
                              {pName && (
                                <div className="mb-4 col-md-3 col-12">
                                  <label className="form-label">
                                    Project Name:{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter project id."
                                    disabled
                                    value={pName}
                                  // {...register("ProjTmplID", {
                                  //   // required: "Ord No is required",
                                  // })}
                                  />
                                  {errors.ProjTmplID && (
                                    <div className="error">
                                      {errors.ProjTmplID.message}
                                    </div>
                                  )}
                                </div>
                              )}
                              <div className="row">
                                {/* form group */}
                                {pId && (
                                  <div className="mb-4 col-md-3 col-12">
                                    <label className="form-label">
                                      Ord No:{" "}
                                      {/* <span className="text-danger">*</span> */}
                                    </label>
                                    <input
                                      type="number"
                                      min="0"
                                      className="form-control"
                                      placeholder="Enter ord no"
                                      // disabled={projectId ? true : false}
                                      {...register("OrdNo", {
                                        // required: "Ord No is required",
                                      })}
                                    />
                                    {errors.OrdNo && (
                                      <div className="error">
                                        {errors.OrdNo.message}
                                      </div>
                                    )}
                                  </div>
                                )}
                                {/* form group */}
                                <div className="mb-4 col-md-12 col-12">
                                  <label className="form-label">
                                    Name <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter name"
                                    {...register("Name", {
                                      required: "Name is required",
                                      validate: validateNoBlankSpaces,
                                    })}
                                  />
                                  {errors.Name && (
                                    <div className="error">
                                      {errors.Name.message}
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                {/* <div className="mb-4 col-md-5 col-12">
                                  <label className="form-label">Type</label>
                                  <select
                                    className="form-select"
                                    {...register("Type", {
                                      required: "Type is required",
                                    })}
                                  >
                                    <option value="">Set Type</option>
                                    {userTypeOption.map((item) => (
                                      <option value={item.id}>
                                        {item.value}
                                      </option>
                                    ))}
                                  </select>
                                  {errors.Type && (
                                    <div className="error">
                                      {errors.Type.message}
                                    </div>
                                  )}
                                </div> */}
                                {/* form group */}
                                <div className="mb-4 col-md-12 col-12">
                                  <label className="form-label">
                                    Description{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <textarea
                                    type="text"
                                    rows={5}
                                    className="form-control"
                                    placeholder="Enter description"
                                    {...register("Dscr", {
                                      required: "Description is required",
                                      validate: validateNoBlankSpaces,
                                    })}
                                  ></textarea>
                                  {errors.Dscr && (
                                    <div className="error">
                                      {errors.Dscr.message}
                                    </div>
                                  )}
                                </div>

                                {/* form group */}
                                <div className="mb-4 col-md-3 col-6">
                                  <label className="form-label">
                                    Approx Days{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="number"
                                    min="0"
                                    className="form-control"
                                    placeholder="Enter Days"
                                    {...register("AprxDays", {
                                      // required: "Approx Days is required",
                                    })}
                                  />
                                  {errors.AprxDays && (
                                    <div className="error">
                                      {errors.AprxDays.message}
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                <div className="mb-4 col-md-3 col-6">
                                  <label className="form-label">
                                    Approx Hours{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="number"
                                    min="0"
                                    className="form-control"
                                    placeholder="Enter Hours"
                                    {...register("AprxHours", {
                                      max: {
                                        value: 23,
                                        message:
                                          "approx hours must be less than 24",
                                      },
                                      // required: "Approx Hours is required",
                                    })}
                                  />
                                  {errors.AprxHours && (
                                    <div className="error">
                                      {errors.AprxHours.message}
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                <div className="mb-4 col-md-3 col-6 ">
                                  <label className="form-label">
                                    Approx Minutes{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="number"
                                    min="0"
                                    className="form-control"
                                    placeholder="Enter Minutes"
                                    {...register("AprxMinutes", {
                                      max: {
                                        value: 59,
                                        message:
                                          "approx minutes must be less than 60",
                                      },
                                      // required: "Approx Minutes is required",
                                    })}
                                  />
                                  {errors.AprxMinutes && (
                                    <div className="error">
                                      {errors.AprxMinutes.message}
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                              </div>
                            </div>
                            <div className=" col-md-12 col-12">
                              <label className="form-label" style={{ margin: "0px" }}>
                                <h3 style={{ margin: "0px", paddingLeft: "20px" }}>
                                  Sub Tasks{" "}
                                  <span className="text-danger">*</span>
                                </h3>
                              </label>
                              <SubTaskList
                                setIsSaveAndAddSubTask={
                                  setIsSaveAndAddSubTask
                                }
                                setIsSaveAndEditSubTask={
                                  setIsSaveAndEditSubTask
                                }
                                setEditSubTaskId={setEditSubTaskId}
                                projectTempId={
                                  taskTempDetail?.data?.ProjTmplID
                                }
                                tName={tName}
                                pName={pName}
                              />
                            </div>
                          </div>
                          <div className="mt-4 mb-4 d-flex justify-content-between">
                            <div className="left d-flex flex-wrap gap-3">
                              <div
                                className="  btn btn-outline-danger me-2"
                                onClick={() => {
                                  reset();
                                  if (pId) {
                                    if (temId) {
                                      navigate(
                                        `/update/project-template/${pId}?taskId=${temId}`
                                      );
                                    } else {
                                      navigate(
                                        `/update/project-template/${pId}`
                                      );
                                    }
                                  } else {
                                    if (temId) {
                                      navigate(
                                        `/task-template?taskId=${temId}`
                                      );
                                    } else {
                                      navigate(`/task-template`);
                                    }
                                  }
                                }}
                              >
                                Cancel
                              </div>
                              <div className="  rounded-circl notification-count">
                                <div
                                  
                                  className="btn btn-dark me-2"
                                  onClick={() => handleExternalSubmit()}
                                >
                                  Attachments
                                </div>
                                <div className="notification-count d-flex justify-content-center">
                                  {attachmentCount}
                                </div>
                              </div>
                              {/* <div className="  rounded-circl notification-count">
                                <a
                                  href="#!"
                                  className="btn btn-dark me-2"
                                  onClick={() => setTab("notifications")}
                                >
                                  Notifications
                                </a>
                                <div className="notification-count">24</div>
                              </div> */}
                            </div>
                            <div className="right">
                              <button className="btn btn-primary  ">
                                Save
                              </button>
                            </div>
                          </div>
                        </form>
                      );
                    case "attachments":
                      return (
                        <Attachment
                          setTab={setTab}
                          setAttachmentCount={setAttachmentCount}
                          setTitle={setTitle}
                          attachmentType={"taskTemp"}
                          TranType={4}
                          AttchType={1}
                        />
                      );
                    case "addUpdateSubTask":
                      return <AddSubTask />;
                    case "notifications":
                      return <></>;
                    // case "attachments":
                    //   return <Attachments />;
                    // case "notifications":
                    //   return <Notifications />;
                    default:
                  }
                })()}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddUpdateTaskTemp;
